import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "survey-item fade-in"
}
const _hoisted_2 = { class: "p-4 is-size-4" }
const _hoisted_3 = { class: "p-4 field" }
const _hoisted_4 = { class: "control is-large pt-4 pb-4" }
const _hoisted_5 = { class: "buttons" }
const _hoisted_6 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.titleWord), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("textarea", {
              class: _normalizeClass(["textarea is-large", `${_ctx.selectedFontFaimlyClassName}`]),
              placeholder: "",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.freeComment) = $event))
            }, null, 2), [
              [_vModelText, _ctx.freeComment]
            ])
          ]),
          _createElementVNode("p", _hoisted_5, [
            _createElementVNode("button", {
              class: "button is-info is-fullwidth",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args))),
              disabled: _ctx.isWhiteout
            }, _toDisplayString(_ctx.nextPageButtonWord), 9, _hoisted_6)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}